export type RewardCodeId = "HoverIdleStart" | "AkiWeb8528";

export type PermanentPurchaseId =
  | "addMousePointer"
  | "hovGainPercent"
  | "timGainPercent";

export type BundleEntitlementKey = "starter_bundle" | "tim_boost_bundle";

export type EntitlementKey =
  | "score_income_bonus"
  | "offline_progress_bonus"
  | "supporter_pack";

export type TokenPackId =
  | "token_pack_100jpy"
  | "token_pack_500jpy"
  | "token_pack_2000jpy"
  | "token_pack_5000jpy";

export type PlayerOwner = {
  readonly ownerId: string;
  readonly ownerKind: "local" | "anonymous" | "signedIn";
};

export interface EntitlementSnapshot {
  readonly scoreIncomeMultiplier: number;
  readonly hoverIncomeMultiplier: number;
  readonly timIncomeMultiplier: number;
  readonly offlineProgressMultiplier: number;
  readonly hasSupporterPack: boolean;
}

export const DEFAULT_ENTITLEMENTS: EntitlementSnapshot = {
  scoreIncomeMultiplier: 1,
  hoverIncomeMultiplier: 1,
  timIncomeMultiplier: 1,
  offlineProgressMultiplier: 1,
  hasSupporterPack: false,
};

export interface HoverIdlePurchasedPermanentItemsState {
  readonly addMousePointer: number;
  readonly hovGainPercent: number;
  readonly timGainPercent: number;
}

export interface HoverIdlePaymentState {
  readonly token: number;
  readonly redeemedRewardCodes: readonly RewardCodeId[];
  readonly purchasedPermanentItems: HoverIdlePurchasedPermanentItemsState;
  readonly entitlements: readonly BundleEntitlementKey[];
  readonly claimedEntitlements: readonly BundleEntitlementKey[];
}

export interface BillingProvider {
  checkout(productId: string): Promise<void>;
  manageSubscription(): Promise<void>;
}

export interface EntitlementProvider {
  getSnapshot(owner: PlayerOwner): Promise<EntitlementSnapshot>;
}

export type RewardCodeRedeemResult =
  | {
      readonly ok: true;
      readonly payment: HoverIdlePaymentState;
    }
  | {
      readonly ok: false;
      readonly reason: "invalid-code" | "already-redeemed";
      readonly payment: HoverIdlePaymentState;
    };

export type PermanentPurchaseResult =
  | {
      readonly ok: true;
      readonly payment: HoverIdlePaymentState;
    }
  | {
      readonly ok: false;
      readonly reason:
        | "insufficient-token"
        | "already-purchased"
        | "max-reached";
      readonly payment: HoverIdlePaymentState;
    };

export type TokenPackCheckoutResult =
  | {
      readonly ok: true;
      readonly payment: HoverIdlePaymentState;
    }
  | {
      readonly ok: false;
      readonly reason: "checkout-failed";
      readonly payment: HoverIdlePaymentState;
    };

export type EntitlementGrantResult =
  | {
      readonly ok: true;
      readonly payment: HoverIdlePaymentState;
    }
  | {
      readonly ok: false;
      readonly reason: "already-granted";
      readonly payment: HoverIdlePaymentState;
    };
